import { Injectable } from '@angular/core';
import { MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import { WelcomeSurveyDialogData } from '../dialogs-data/welcome-survey-dialog-data';
import { WelcomeSurveyDialogComponent } from '../dialogs/welcome-survey-dialog/welcome-survey-dialog.component';

@Injectable()
export class WelcomeSurveyDialogService {
    constructor(private dialog: MatDialog) { }
    matDialogRef: MatDialogRef<WelcomeSurveyDialogComponent>;

    open(welcomeSurveyDialogData: WelcomeSurveyDialogData) {
        const matDialogConfig = new MatDialogConfig();
        matDialogConfig.panelClass = 'myapp-dialog';
        matDialogConfig.width = '50%';
        matDialogConfig.data = welcomeSurveyDialogData;
        matDialogConfig.disableClose = true;
        matDialogConfig.hasBackdrop = true;
        this.matDialogRef = this.dialog.open(WelcomeSurveyDialogComponent, matDialogConfig);
    }

}
